import { companyReportsAxiosInstance } from './axiosInstance.service';

export const subscribeForDUN = (dun: string) => {
  return companyReportsAxiosInstance.post(
    '/monitoring',
    {
      dun,
    },
  );
};

export const unsubscribeForDUN = (dun: string) => {
  return companyReportsAxiosInstance.delete(
    `/monitoring/${dun}`,
  );
};
